__turbopack_context__.v({
  "closing": "global-search-form-module-scss-module__bWgymq__closing",
  "global-search-container": "global-search-form-module-scss-module__bWgymq__global-search-container",
  "global-search-form": "global-search-form-module-scss-module__bWgymq__global-search-form",
  "row": "global-search-form-module-scss-module__bWgymq__row",
  "slide-down": "global-search-form-module-scss-module__bWgymq__slide-down",
  "slide-up": "global-search-form-module-scss-module__bWgymq__slide-up",
});
